export enum EActivitySimulationType {
    NC = 1,
    No = 2,
    Yes = 3,
    RemiseEnSuspension = 4,
    MaintienEnSuspension = 5,
    CirculationAirSuffisanteEtRepresentative
}
